<template>
    <div ref="loader" class="loader">
        <div class="loader--logo">
            <p ref="letter" class="loader--logo--letter" v-for="letter in logo" :key="letter.id">
            {{ letter }}
            </p>
        </div>
    </div>
</template>

<script>
import { TimelineMax, Expo } from 'gsap';
import store from '../store/Store';

export default {
    data() {
        return {
            state: store.state
        }
    },
    computed: {
        logo() {
            let str = 'Jia Szeto';
            let letters = [];

            for (let letter of str) {
                letters.push(letter);
            }
            return letters;
        }
    },
    mounted() {
        this.animateLogo();
    },
    methods: {
        animateLogo() {
            const letters = this.$refs.letter;
            const tl = new TimelineMax();

            // Animate IN
            for(let i in letters) {
                tl.fromTo(letters[i], .3, {y: '25rem', opacity: 0}, {y: 0, opacity: 1},'-=.2');
            }

            // Animate OUT
            setTimeout(() => {
                for(let i in letters) {
                    tl.to(letters[i], .3, {y: '-25rem', opacity: 0},'-=.2');
                }
            }, 1500);

            // Hide LOADER
            setTimeout(() => {
                this.hideLoader();
            }, 2500);
 
        },
        hideLoader() {
            const loader = this.$refs.loader;
            const tl = new TimelineMax();
            tl.to(loader, 1, {opacity: 0, ease: Expo.easeOut, onComplete: () => {
                this.state.loaded = true;
            }});
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Loader.vue